<template>
  <!-- 儿童入学健康检查表 -->
  <div v-if="model && model.congHuaKindergarten">
    <div id="print_congHuaKindergarten" class="page congHuaKindergarten-page">
      <div style="display: flex;font-size: 23px;text-align: center;font-weight: 600;">
        <table style="width: 100%;border-collapse: collapse;border:none;letter-spacing: 5px;margin-top: 5px;">
          <tbody>
            <tr style="width: 100%;border-collapse: collapse;border:none;">
              <td style="border-collapse: collapse;border:none;">{{ model.congHuaKindergarten.reportName ? model.congHuaKindergarten.reportName : "幼儿园体检报告单" }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <table style="padding-left: 10px;text-align: left;width: 100%;margin-top:10px;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 30px;border:none;margin-top: 10px;">
            <td style="width: 18%;border-collapse: collapse;border:none;">姓名：<span>{{ model.congHuaKindergarten.name ? model.congHuaKindergarten.name : "" }}</span></td>
            <td style="width: 13%;border-collapse: collapse;border:none;">性别：<span>{{ model.congHuaKindergarten.sex ? model.congHuaKindergarten.sex : "" }}</span></td>
            <td style="width: 23%;border-collapse: collapse;border:none;">出生日期：<span>{{ model.congHuaKindergarten.birthday ? model.congHuaKindergarten.birthday : "" }}</span></td>
            <td style="width: 20%;border-collapse: collapse;border:none;">班级：<span>{{ model.congHuaKindergarten.className ? model.congHuaKindergarten.className : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">体检日期：<span>{{ model.congHuaKindergarten.checkDate ? model.congHuaKindergarten.checkDate : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="text-align: center;width: 100%;border-collapse: collapse;border: 1px solid black;">
        <tbody>
          <tr style="line-height: 30px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">检查项目</td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;">结果</td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;">评价</td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">检查项目</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;">结果</td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">身高(CM)</td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.height ? model.congHuaKindergarten.height : "" }}</span></td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.heightAssessment ? model.congHuaKindergarten.heightAssessment : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">血红蛋白值(g/L)</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.hemoglobinValue ? model.congHuaKindergarten.hemoglobinValue : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">体重(kg)</td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.weight ? model.congHuaKindergarten.weight : "" }}</span></td>
            <td style="width: 80px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.weightAssessment ? model.congHuaKindergarten.weightAssessment : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">视力(左/右)</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.leftEyeVision ? model.congHuaKindergarten.leftEyeVision : "" }} / {{ model.congHuaKindergarten.rightEyeVision ? model.congHuaKindergarten.rightEyeVision : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">身长别体重</td>
            <td colspan="2" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.bmiAssessment ? model.congHuaKindergarten.bmiAssessment : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">体格发育评价</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.physicalDevelopmentAssessment ? model.congHuaKindergarten.physicalDevelopmentAssessment : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">牙齿数量(颗)</td>
            <td colspan="2" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.numberTeeth != null || model.congHuaKindergarten.numberTeeth == 0 ? model.congHuaKindergarten.numberTeeth : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">发育评估</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.developmentaAssessment ? model.congHuaKindergarten.developmentaAssessment : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">龋齿</td>
            <td colspan="2" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.cariesTotalNumber != null || model.congHuaKindergarten.cariesTotalNumber == 0 ? model.congHuaKindergarten.cariesTotalNumber : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">是否高危儿</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.highRiskChildren ? model.congHuaKindergarten.highRiskChildren : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">心肺</td>
            <td colspan="2" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.heart ? model.congHuaKindergarten.heart : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">腹部</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.abdomen ? model.congHuaKindergarten.abdomen : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">高危因素</td>
            <td colspan="4" style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.highRiskFactors ? model.congHuaKindergarten.highRiskFactors : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">体格检查其他</td>
            <td colspan="4" style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.physicalCheckOther ? model.congHuaKindergarten.physicalCheckOther : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">转诊原因</td>
            <td colspan="4" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.reasonReferral ? model.congHuaKindergarten.reasonReferral : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">其他</td>
            <td colspan="4" style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.other ? model.congHuaKindergarten.other : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;">
            <td colspan="5" style="width: 100px;border-collapse: collapse;border: 1px solid black;font-weight: bold;text-align: center;letter-spacing: 2px;">上面都是免费国家基本公共卫生项目 0 至 6 岁儿童健康管理服务内容</td>
          </tr>
          <tr style="line-height: 25px;">
            <td style="width: 100px;border-collapse: collapse;border: 1px solid black;">听力筛查情况</td>
            <td colspan="2" style="width: 160px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.listening ? model.congHuaKindergarten.listening : "" }}</span></td>
            <td style="width: 110px;border-collapse: collapse;border: 1px solid black;">屈光筛查情况</td>
            <td style="width: 130px;border-collapse: collapse;border: 1px solid black;white-space: normal; word-break: break-all; line-height: 1.4;"><span>{{ model.congHuaKindergarten.refraction ? model.congHuaKindergarten.refraction : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <table style="width: 100%;border-collapse: collapse;border:none;margin-top: 10px;font-size: 16px;">
        <tbody>
          <tr style="line-height: 30px;border:none;"><td style="width: 35%"></td><td>体检结果建议：详见集体儿童体检异常告知！谢谢合作</td></tr>
        </tbody>
      </table>
      <table style="width: 100%;border-collapse: collapse;border:none;margin-top: 10px;font-size: 16px;">
        <tbody>
          <tr style="line-height: 30px;border:none;"><td style="width: 45%"></td><td>体检机构：{{ model.congHuaKindergarten.hospitalName ? model.congHuaKindergarten.hospitalName : "" }}</td></tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>

import {_congHuaKindergarten} from "@/services/report/report";
export default {
  name: "congHuaKindergartenReport",
  props: {
    physicalId:[String,Number],
    barCode:[String,Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        congHuaKindergarten:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    };
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'congHuaKindergarten'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'congHuaKindergarten') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.congHuaKindergarten(this.barCode);
      }
    },
    congHuaKindergarten(barCode) {
      _congHuaKindergarten({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
        /*if(this.model.congHuaKindergarten.barCodeImage){
          this.drawBase64ToCanvas(this.model.congHuaKindergarten.barCodeImage);
        }*/
      })
    },
    drawBase64ToCanvas (base64String) {
      const canvas = this.$refs.barcodeImage;
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 设置Canvas尺寸与图片一致
        canvas.width = img.width;
        canvas.height = img.height;
        // 绘制图片
        ctx.drawImage(img, 0, 0);
      };

      img.onerror = () => console.error("图片加载失败");
      img.src = base64String;
    }
  }
}
</script>

<style lang="postcss" scoped>
@media print {
  .congHuaKindergarten-page {
    page: congHuaKindergarten-page; /* 绑定唯一命名 */
  }
  @page congHuaKindergarten-page {size: A5 landscape;margin: 5mm;}
  body {width: 210mm !important;height: 148mm !important;padding: 0 !important;margin: 0 !important;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 148mm;margin:0 auto;padding: 5mm;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;box-sizing: border-box;background: #fff; font-size: 15px;}

</style>

